import { useApplicationStore as C, IncomeCollectionType as ie, useProviderStore as I, useTermsService as st, InjectionKeys as fe, useApplicationService as te, extractProviderKey as ce, DynamicProviderKey as be, getProviderModule as Ne, useLocaleStore as ve, useSessionStore as x, useFinishFlow as it, useGeneralRouteMappings as Te, toRouteLocation as Me, fillPath as at, useSwitchProvider as De, useRefreshProviderStipulationStatus as ut, useStipulationService as lt, useLogger as V, useErrorStore as Oe, useAppI18n as ct, useFlowService as Fe, pendingResponse as Ee, prequalifiedResponse as ae, query as G, responseByProvider as ue, responseByProviderKey as pt, extractOptionalProviderKey as dt, approvedResponse as ft, enumToPath as vt, usePublishEvent as yt, useMemoize as Z, useMerchantStore as re, fullDaysBetween as mt, localDate as ht, usePaymentPlanService as gt, useCurrentApplyResponse as wt, useNavigationStore as Pt } from "@versatile-credit-apply/sdk";
import { useAcceptOffer as lo, useApplicationService as co, useFlowService as po, useLogger as fo, useMerchantLegalName as vo, useMerchantName as yo, usePaymentPlanService as mo, useStipulationService as ho, useSubmitApplication as go, useTestCaseService as wo, useValidationService as Po } from "@versatile-credit-apply/sdk";
import { ApplicantType as O, ApplyResponseCode as S, useOmniApplyApiState as ye, ProviderApplyOperation as X, StipulationStatus as St, useOmniApplyApiClient as me, ApiException as Ct, HEADER_SESSION_ID as At, VerifyCodeStatus as It } from "@versatile-credit-apply/omni-apply-client";
import { useOmniApplyApiClient as Co } from "@versatile-credit-apply/omni-apply-client";
import { computed as i, toValue as F, inject as B, onMounted as $, provide as ne, unref as ee, ref as m, nextTick as k, watch as z, onUnmounted as oe, markRaw as _e, toRef as $e, watchEffect as Rt } from "vue";
import { useRoute as j, useRouter as L } from "vue-router";
import { sortBy as pe, keyBy as bt, isNaN as Et } from "lodash-es";
import { useIntervalFn as _t, computedAsync as xe } from "@vueuse/core";
import { useI18n as se } from "vue-i18n";
import Kt from "mitt";
class Nr {
  _field;
  _value;
  constructor(t, r) {
    this._field = t, this._value = r;
  }
  get id() {
    return this._field.id;
  }
  get path() {
    return this._field.path;
  }
  get type() {
    return this._field.type;
  }
  get rules() {
    return this._field.rules;
  }
  get field() {
    return this._field;
  }
  get value() {
    return this._value;
  }
}
const Y = () => {
  const e = C();
  return i(() => e.application);
}, Nt = (e) => {
  const t = Y();
  return i(() => e === O.PRIMARY ? t.value?.primary?.income?.grossAnnualCents : e === O.JOINT ? t.value?.joint?.income?.grossAnnualCents : void 0);
}, Tt = (e) => {
  const t = Y();
  return i(() => e === O.PRIMARY ? t.value?.primary?.income?.grossMonthlyCents : e === O.JOINT ? t.value?.joint?.income?.grossMonthlyCents : void 0);
}, Mt = (e) => {
  const t = Y();
  return i(() => e === O.PRIMARY ? t.value?.primary?.income?.netMonthlyCents : e === O.JOINT ? t.value?.joint?.income?.netMonthlyCents : void 0);
}, Dt = (e) => {
  const t = Y();
  return i(() => e === O.PRIMARY ? t.value?.primary?.income?.netAnnualCents : e === O.JOINT ? t.value?.joint?.income?.netAnnualCents : void 0);
}, Tr = (e, t) => {
  let r;
  switch (t) {
    case ie.GROSS_MONTHLY:
      r = Tt(e);
      break;
    case ie.NET_MONTHLY:
      r = Mt(e);
      break;
    case ie.NET_ANNUAL:
      r = Dt(e);
      break;
    default:
      r = Nt(e);
  }
  return r;
}, Mr = (e, t) => {
  const r = C();
  return i(() => {
    const n = F(e), o = r.application, s = n === O.PRIMARY ? o?.primary : o?.joint;
    switch (t) {
      case "first":
        return s?.firstName ?? "";
      case "last":
        return s?.lastName ?? "";
      default:
        return `${s?.firstName ?? ""} ${s?.lastName ?? ""}`.trim();
    }
  });
}, Ot = (e) => {
  const t = C();
  return i(() => t.getApplicationValue(F(e)));
}, he = () => {
  const e = C();
  return i(() => e.applyMode);
}, ke = () => {
  const e = C(), t = j();
  return i(
    () => t.params.applyStage ?? e.applyStage ?? e.applyMode
  );
}, Dr = () => ze(
  (e) => e.responseCode === S.APPROVED
), ze = (e = () => !0) => {
  const t = I();
  return i(() => t.applyResponses.filter(e));
}, ge = (e) => {
  const t = B(e);
  if (!t)
    throw new Error(`Unable to inject: ${e.description}, this is fatal!`);
  return t;
}, Le = st, Or = () => ge(fe.AccountServiceKey), Fr = () => ge(fe.GoogleTagManagerKey), Ue = () => ge(fe.VerificationServiceKey), $r = (e, t, r) => {
  const n = Le(), o = t ?? e, s = {
    contentType: e,
    data: n.getApplyTermsUrl(e, r)
  }, a = {
    contentType: o,
    data: n.getApplyTermsUrl(o, r)
  };
  return {
    content: s,
    downloadableContent: a,
    printableContent: a
  };
}, Be = () => {
  const e = I();
  return i(() => e.cascade || []);
}, xr = (e) => {
  const t = te();
  $(async () => {
    await t.completeApplication(), e.onComplete && e.onComplete();
  });
}, Ft = () => {
  const e = I();
  return i(() => {
    const t = e.currentProviderKey;
    if (!t)
      throw Error("Provider is not set in the store!");
    return t;
  });
}, kr = () => {
  const e = I();
  return i(() => {
    const t = e.currentProviderConfig;
    if (!t)
      throw Error("Config for current provider is not set in the store!");
    return t;
  });
}, We = /* @__PURE__ */ Symbol("currentProvider"), zr = (e) => {
  ne(We, e);
}, _ = () => {
  const e = I(), t = B(We, null);
  return i(() => ee(t) ?? e.currentProviderKey);
};
function $t(e) {
  const t = I();
  return i(() => {
    const r = F(e);
    if (!r)
      return;
    const n = t.currentProviderKey;
    return r === n ? t.currentProviderConfig : t.findProviderConfig(r);
  });
}
const Ve = () => {
  const e = _();
  return $t(e);
}, Ge = (e) => {
  const t = e || _();
  return i(() => {
    const r = t.value;
    return r ? ce(r) : null;
  });
};
function xt() {
  const e = _(), t = I();
  return i(() => {
    if (!e.value)
      return [];
    const r = t.cascade, n = new be(e.value ?? "").providerKey, o = r.findIndex(
      (p) => new be(p.providerKey).providerKey === n
    );
    if (o < 0)
      return [];
    const s = r[o];
    let a = o, u = o;
    for (let p = o - 1; p >= 0; p--) {
      const l = r[p];
      if (l?.cascadeGroup && l.cascadeGroup === s?.cascadeGroup)
        a = p;
      else
        break;
    }
    for (let p = o + 1; p < r.length; p++) {
      const l = r[p];
      if (l?.cascadeGroup && l.cascadeGroup === s?.cascadeGroup)
        u = p;
      else if (l?.autoSubmit)
        u = p;
      else
        break;
    }
    return r.slice(a, u + 1);
  });
}
function Lr() {
  const e = xt();
  return i(() => e.value.map((t) => Ne(t.providerKey)));
}
const kt = /\/:[a-zA-Z0-9-_]+/g, zt = /\//g, Lt = (e, t, r) => `/providers/:providerKey(${t}[^/]*)/${e}${r}`, Ur = (e) => ({
  defineRoute: (t) => {
    const r = t.path, n = t.meta ?? {};
    n.providerKey = e;
    const o = r.substring(1).replace(kt, "").replace(zt, "."), s = `${e}.${t.name ?? o}`, a = t.experienceType, u = a ? encodeURIComponent(a) : ":experienceType", p = Lt(
      u,
      e,
      r
    );
    t.inherit && (n.extends = typeof t.inherit == "boolean" ? o : t.inherit);
    const l = t.component;
    if (l)
      return {
        meta: n,
        name: s,
        path: p,
        component: l,
        children: t.children,
        beforeEnter: t.beforeEnter,
        props: t.props
      };
    const d = t.redirect;
    if (d)
      return {
        name: s,
        path: p,
        redirect: d
      };
    const v = t.children;
    if (v)
      return {
        name: s,
        path: p,
        children: v
      };
    throw new Error(`Invalid route definition [${t.path}]`);
  }
}), Br = () => {
  const e = I();
  return i(() => e.cascade?.length > 1);
}, W = () => {
  const e = ve();
  return i(() => e.experienceType ?? "in_store");
}, Wr = () => {
  const e = W();
  return i(() => e.value === "at_home");
}, Vr = () => {
  const e = W();
  return i(() => e.value === "in_store");
}, Gr = () => {
  const e = x();
  return i(() => e.isActive || !1);
}, Ut = (e) => i(() => e.timedout), Bt = (e) => i(() => e.timeout), qr = () => {
  const e = it(), t = L(), r = j(), n = Te(), o = x(), s = _(), a = ye(), u = i(() => a.callInProgress), p = Ut(o), l = Bt(o), d = m(!1), v = async (T) => {
    const h = r.meta?.screenId, P = {
      providerKey: s.value ?? void 0,
      screenId: h
    };
    d.value = !1;
    const { transition: y } = await e(
      T ? "timeout" : "canceled",
      P
    );
    await k();
    const K = {
      finish: "false"
    };
    y?.destination && (K.destination = y.destination), await t.replace(
      Me({
        to: n.session_timeout,
        query: K
      })
    );
  }, w = () => {
    u.value || (d.value = !0);
  }, R = m(), E = m();
  z(l, () => A(!1)), z(u, (T) => {
    T || k().then(() => A(!1));
  }), z(p, (T) => {
    T && k().then(() => v(!1));
  });
  const A = (T = !1) => {
    R.value && clearTimeout(R.value), E.value && clearTimeout(E.value), T ? v(!1) : (l.value.timeoutAfterMillis && (R.value = window.setTimeout(
      () => v(!0),
      l.value.timeoutAfterMillis
    )), l.value.warnAfterMillis && (E.value = window.setTimeout(
      w,
      l.value.warnAfterMillis
    ), d.value = !1));
  };
  return $(() => A(!1)), {
    reset: A,
    displayWarning: i(() => d.value || !1)
  };
}, Wt = () => {
  const e = x();
  return i(() => e.sessionId ?? null);
}, Jr = () => {
  const e = x();
  return i(() => e.flowSessionId ?? null);
}, qe = (e, t, r) => {
  const n = r?.params?.experienceType ?? "in_store", o = encodeURIComponent(n);
  return `/providers/${encodeURIComponent(e)}/${o}${t}`;
}, Je = (e, t, r) => {
  const n = {
    path: at(
      qe(e, t, r),
      r?.params
    )
  };
  return r?.query && (n.query = r.query), r?.replace && (n.replace = r.replace), n;
}, we = (e, t, r, n) => {
  const o = Je(t, r, n);
  return n?.replace ? e.replace(o) : e.push(o);
}, Hr = (e) => {
  const t = W(), r = _(), n = i(
    () => F(e?.experienceType) ?? t.value
  ), o = i(
    () => F(e?.providerKey) ?? r.value
  ), s = L();
  return (a, u) => {
    const p = {
      ...u?.params,
      experienceType: n.value
    }, l = { ...u, ...p };
    return we(s, o.value, a, l);
  };
}, Vt = (e) => i(() => {
  const t = F(e);
  return t ? Ne(t) : void 0;
}), jr = () => {
  const e = _(), t = he(), r = m(e.value), n = I(), o = De();
  return z(r, (a) => {
    a && n.switchProvider(a);
  }), {
    commit: async () => {
      const a = r.value;
      let u = t.value;
      a && u && (Vt(a).value?.switchToFullApplyAfterPrequal && (u = "full"), await o({
        providerKey: a,
        applyMode: u
      }));
    }
  };
}, Gt = () => {
  const e = I();
  return i(() => e.primary);
}, Yr = () => {
  const e = ke(), t = Gt(), r = _();
  return i(() => e.value === "offer" ? !1 : r.value === t.value?.providerKey);
}, Qr = () => {
  const e = C();
  return i(() => e.application?.jointEnabled === !0);
}, Zr = () => {
  const e = C();
  return i(() => e.jointSelectionEnabled ?? !0);
}, qt = (e, t, r, n, o) => we(
  e,
  t,
  `/apply/${r}${n}`,
  o
), Xr = (e, t, r) => {
  const n = r?.params?.applyStage ?? "full";
  return qe(
    e,
    `/apply/${n}${t}`,
    r
  );
}, Jt = (e) => {
  const t = e?.applyStage ?? ke(), r = e?.providerKey ?? _(), n = L();
  return (o, s) => {
    const a = ee(t) ?? "full", u = ee(r);
    if (!u)
      throw new Error("Unable to resolve active provider key for navigation");
    return qt(n, u, a, o, s);
  };
}, Ht = (e, t) => e ? X.isSoftHit(e) : t !== "full", He = (e, t = !1) => {
  let r = e?.params?.applyStage;
  !r && S.isAnyPreApproval(e.responseCode) && (r = "offer"), !r && e?.operation && (r = jt(e.operation)), r || (r = "full");
  let n = `/apply/${encodeURIComponent(r)}`;
  return n += e.resume ? "/resume/responses" : "/responses", t ? n += `/${encodeURIComponent(e.responseCode)}` : e.responseCode === S.PENDING ? n += Ht(e.operation, r) ? "/pending_offer" : "/pending_full" : n += `/${encodeURIComponent(e.responseCode)}`, n;
}, en = (e) => Je(
  e.providerKey,
  He(e, !0)
), jt = (e) => je(e), je = (e) => {
  switch (e) {
    case X.PREQUALIFY:
      return "prequalify";
    case X.PRESCREEN:
      return "prescreen";
    default:
      return "full";
  }
}, tn = (e) => e === S.PENDING, Yt = (e, t, r) => we(
  e,
  t.providerKey,
  He({
    ...r,
    responseCode: t.responseCode,
    operation: t.operation
  }),
  r
), rn = () => {
  const e = L(), t = W(), r = he();
  return (n, o) => {
    const s = o?.params?.applyMode ?? je(n.operation) ?? r?.value ?? "full", a = o?.params?.experienceType ?? t.value ?? "in_store", u = { ...o?.params, applyMode: s, experienceType: a }, p = { ...o, params: u };
    return Yt(e, n, p);
  };
}, nn = () => {
  const e = C();
  return i(() => e.originalApplication);
}, on = () => {
  const e = te(), t = Jt();
  $(async () => {
    const r = await e.patchApplication();
    if (r.provider && (r.provider.responseCode === S.PREQUALIFIED || r.provider.responseCode === S.APPROVED))
      await t("/patchSuccess");
    else if (r.provider && (r.provider.responseCode === S.DECLINED || r.provider.responseCode === S.PENDING))
      await t("/responses/" + r.provider.responseCode);
    else
      throw new Error("Unhandled patch response!");
  });
}, sn = (e) => {
  const t = I(), r = C(), n = i(() => e.value ? t.findOverrides(e.value) || {} : {}), o = i(() => {
    const u = n.value?.downPaymentAmountCents;
    return u !== void 0 ? u : r.application?.downPaymentAmountCents;
  });
  return {
    amount: o,
    setAmount: (u) => {
      e.value && t.addOverrides(e.value, {
        ...n.value,
        downPaymentAmountCents: u
      });
    },
    commit: () => r.setApplicationValue("downPaymentAmountCents", o.value)
  };
}, Qt = (e) => {
  const t = I();
  return i(() => {
    const r = t.preauthResponses, n = (o) => e !== !0 ? !0 : o.responseCode === S.PREAPPROVED || o.responseCode === S.PREQUALIFIED;
    return pe(r.filter(n), ["approvedAmountCents"]).reverse();
  });
}, an = () => {
  const e = C();
  return i(() => e.primaryProviderApplyMode);
}, un = () => {
  const e = C(), t = I(), r = _();
  return i(() => {
    const n = e.previousResponses, o = bt(
      t.cascade,
      "providerKey"
    );
    let s = Ye(
      n,
      r.value
    );
    const a = er(
      n,
      r.value
    );
    if (s < 0) {
      if (a < 0)
        return [];
      s = a;
    }
    const u = [];
    if (s !== a) {
      const d = n[s];
      d && u.push(d);
    }
    const p = n[s], l = o[p?.provider?.providerKey ?? ""];
    for (let d = s + 1; d < n.length; d++) {
      const v = n[d];
      if (v) {
        const w = o[v.provider?.providerKey ?? ""];
        if (d === s)
          continue;
        if (w?.cascadeGroup !== l?.cascadeGroup)
          break;
        u.push(v);
      }
    }
    return u.filter((d) => {
      const v = d.provider;
      if (!v || v.providerKey == r.value)
        return !1;
      switch (d.provider?.responseCode) {
        case S.DECLINED:
        case S.NOOFFER:
          return !0;
        case S.PENDING:
          return X.isSoftHit(v.operation);
        default:
          return !1;
      }
    });
  });
}, ln = () => {
  const e = C(), t = _();
  return i(() => {
    const r = e.previousResponses, n = Ye(
      r,
      t.value
    );
    return n < 0 ? null : r[n];
  });
}, Ye = (e, t) => {
  for (let r = e.length - 1; r >= 0; r--) {
    const n = e[r];
    if (n && Zt(n, t))
      return r;
  }
  return -1;
}, Zt = (e, t) => !e.provider || e.provider.providerKey === t ? !1 : !Xt(e), Xt = (e) => e.provider?.autoSubmit ?? !1;
function er(e, t) {
  return t ? e.findIndex(
    (r) => r.provider?.providerKey === t
  ) : -1;
}
const cn = (e) => {
  const t = C(), r = I(), n = ut(), o = lt(), s = V("useRefreshPendingStipulation"), a = () => {
    const l = F(e), v = ("providerKey" in l ? r.findStipulations(l.providerKey) : t.stipulations).filter((w) => w.type === l.type).filter((w) => w.status === St.PENDING);
    return v.length ? v[v.length - 1] ?? null : null;
  }, p = _t(() => {
    const l = a(), d = F(e);
    l && "providerKey" in d ? n(d.providerKey, l).catch(
      (v) => s.error("Failure trying to refresh stipulation", v)
    ) : l ? o.refreshSessionStipulationStatus(l).catch((v) => s.error("Failure trying to refresh stipulation", v)) : p.pause();
  }, 2500);
  return i(() => a() != null);
}, pn = () => {
  const e = C();
  return i(() => e.stipulations);
}, dn = () => {
  const e = Be().value, t = e[0];
  return i(
    () => e.some(
      (r) => r.cascadeGroup !== t?.cascadeGroup && r.autoSubmit
    )
  );
}, fn = (e) => {
  const t = me(), r = Ge(), n = e ?? r.value;
  return (o) => n ? t.validateBankCard(n, o) : Promise.resolve(void 0);
}, tr = () => {
  const e = C();
  return (t, r) => {
    e.setApplicationValue(t, r);
  };
}, vn = () => {
  const e = C();
  return (t) => {
    e.setApplicationValues(t);
  };
}, rr = ["employed", "self_employed", "other"], yn = (e) => {
  const t = Ot(
    () => `${e.value}.income.type`
  );
  return i(() => {
    const r = t.value;
    return r ? rr.includes(r) : !1;
  });
}, mn = () => {
  const e = Ve(), t = se();
  return i(() => e.value?.properties.bankName ?? t.t("provider.bank_name"));
}, hn = () => {
  const e = Ve(), t = se();
  return i(() => e.value?.properties.bankNameAbbreviation ?? t.t("provider.bank_name"));
}, gn = () => m(), Qe = /* @__PURE__ */ Symbol("page-title"), wn = (e) => {
  ne(Qe, e);
}, nr = () => {
  const e = B(Qe);
  return (t) => {
    e && (e.value = t);
  };
}, Pn = (e) => {
  const t = se(), r = nr();
  e && typeof e != "string" && z(e, (s) => r(t.t(s || "page_title")), {
    immediate: !0
  }), $(() => {
    (!e || typeof e == "string") && r(t.t(e || "page_title"));
  });
};
function Sn(e) {
  const t = or(e);
  return [t.call, t.processing, t.error];
}
function or(e) {
  const t = m(!1), r = m();
  return {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    call: async (...n) => {
      t.value = !0;
      try {
        return await e(...n);
      } catch (o) {
        throw r.value = o, o;
      } finally {
        t.value = !1;
      }
    },
    error: i(() => r.value),
    processing: i(() => t.value)
  };
}
const Cn = () => {
  const e = W();
  return i(() => e.value !== "in_store");
}, An = (e) => {
  const t = m();
  return $(() => {
    const r = e.component?.value?.$el || document.body;
    t.value = r?.querySelector(e.selector) || r;
  }), i(() => t.value);
}, In = (e, t) => {
  $(() => {
    window.addEventListener(e, t);
  }), oe(() => {
    window.removeEventListener(e, t);
  });
}, Rn = (e, t) => {
  const r = m();
  $(() => {
    r.value = window.setInterval(e, t);
  }), oe(() => {
    window.clearInterval(r.value);
  });
}, sr = () => {
  const e = x(), t = ye();
  return i(() => e.environment ?? t.environment);
}, ir = () => {
  const e = sr();
  return i(() => e.value === "prod");
}, bn = () => {
  const e = ir();
  return i(() => !e.value);
}, En = () => {
  const e = Oe();
  return i(() => {
    const t = e.error;
    return t instanceof Ct ? t : void 0;
  });
};
function _n(e) {
  const t = ct(), r = Oe(), n = W();
  return i(() => {
    const o = e?.error?.value ?? r.error;
    if (!o)
      return {
        instructionsKey: q(n.value),
        messageKey: J(),
        headingKey: H()
      };
    if (typeof o == "string")
      return {
        instructionsKey: q(n.value),
        messageKey: J(),
        headingKey: H(),
        details: o
      };
    if (o instanceof Error)
      return {
        instructionsKey: q(n.value),
        messageKey: J(),
        headingKey: H(),
        details: o.message
      };
    if (typeof o == "object") {
      const s = o, a = s._error?.cloudRequestId, u = s._error?.message ?? s.message ?? "", p = s._error?.code ?? s.code, l = s._statusCode;
      let d = p;
      return s._statusCode && (d ? d = `(${s._statusCode}) ${d}` : d = s._statusCode), {
        ...ar(t, n.value, p, l),
        code: d,
        trackingId: a,
        details: u
      };
    }
    return {
      instructionsKey: q(n.value),
      messageKey: J(),
      headingKey: H()
    };
  });
}
function de(e, t) {
  return `${e}.${t}`;
}
function ar(e, t, r, n) {
  const o = r ?? "general", s = n ?? 500;
  let a, u, p;
  if (o !== "general") {
    const l = `errors.${o}.message.user`, d = de(
      `errors.${o}.instructions`,
      t
    ), v = `errors.${o}.heading`;
    u = e.te(d) ? d : void 0, a = e.te(l) ? l : void 0, p = e.te(v) ? v : void 0;
  }
  if (!u) {
    const l = de(
      `errors.${s}.instructions`,
      t
    );
    u = e.te(l) ? l : q(t);
  }
  if (!a) {
    const l = `errors.${s}.message`;
    a = e.te(l) ? l : J();
  }
  if (!p) {
    const l = `errors.${s}.heading`;
    p = e.te(l) ? l : H();
  }
  return {
    instructionsKey: u,
    messageKey: a,
    headingKey: p
  };
}
function q(e) {
  return de("errors.general.instructions", e);
}
function J() {
  return "errors.general.message.user";
}
function H() {
  return "errors.general.heading";
}
const Pe = () => {
  const e = x();
  return i(() => e.flowType);
}, Kn = () => {
  const e = L(), t = j(), r = Pe(), n = Te(), o = i(() => t.meta?.screenId);
  return async (s) => {
    const a = r.value;
    if (s === "timeout")
      throw new Error(
        "Flow timeout is not supported here. Use SessionService instead."
      );
    await e.push(
      Me({
        to: n.exit,
        query: {
          flowType: a,
          screenId: o.value,
          outcome: s
        }
      })
    );
  };
};
function ur() {
  const e = x();
  return i(() => e.providerResume?.requestedProviderKey);
}
const Nn = (e) => {
  const t = m(!1), r = V("use-resume-application.ts"), n = C(), o = I(), s = x(), a = Fe(), u = De(), p = te(), l = (c) => (s.providerResume?.replayResponseCodes ?? []).includes(c.responseCode), d = ze(), v = i(
    () => d.value.filter((c) => Ee(c))
  ), w = Qt(), R = i(
    () => w.value.filter(
      (c) => ae(c)
    )
  ), E = ur(), A = Be(), T = () => {
    const c = pe(
      d.value.filter(l),
      ["applicationDateTime"]
    );
    if (c.length)
      return c[0];
    const g = pe(
      w.value.filter(l),
      ["applicationDateTime"]
    );
    if (g.length)
      return g[0];
  }, h = async (c) => {
    const g = Re(c);
    if (g)
      return await g;
    if (nt(c.providerKey))
      return D();
    r.info("A full apply is present in the session, not resuming..."), await f();
  }, P = async (c) => {
    r.info(
      "Resuming a full apply in pending state for:",
      c.providerKey
    ), await p.hydrateProvider(c), await u({
      providerKey: c.providerKey,
      applyMode: "full"
    }), await e.handlePendingProvider(c);
  }, y = async () => {
    for (const N of R.value)
      await p.hydrateProvider(N);
    let c;
    if (E.value && (c = G(A, (N) => {
      const M = G(
        R,
        ue(N)
      );
      return M && M.providerKey === E.value ? ae(M) : !1;
    })), c || (c = G(A, (N) => {
      const M = G(
        R,
        ue(N)
      );
      return M ? ae(M) : !1;
    })), !c)
      throw new Error("Cannot resume, no provider found!");
    const g = G(
      R,
      ue(c)
    );
    if (!g)
      throw new Error("Cannot resume, no response found!");
    await Q(g, {
      // we disable hydration here because we've already done it above.
      hydrate: !1
    }), r.info(
      "Resuming multiple offer flow starting with:",
      c.providerKey
    ), await e.handleMultipleOffers({
      provider: g,
      requestedProviderKey: E.value
    });
  }, K = async () => {
    const c = R.value.first();
    await Q(c), r.info("Resuming prequalification of", c.providerKey), await e.handleSingleOffer(c);
  }, D = async () => {
    const c = d.value.first();
    await Q(c), r.info("Resuming full apply for", c.providerKey), await e.handleSingleOffer(c);
  }, f = async () => {
    const c = await a.restartFlow();
    await k(), await e.handleFlowRestart(c);
  }, b = (c, g, N) => {
    for (const M of g)
      if (c.includes(M))
        return M;
    return N;
  }, U = (c) => {
    const g = pt(c.providerKey), N = R.value.find(g);
    if (N)
      return N.responseCode === S.PREAPPROVED ? "prescreen" : "prequalify";
    const M = o.findProviderConfig(c.providerKey)?.applyModes ?? [];
    return w.value.find(g) ? b(
      M,
      ["prequalify", "prescreen"],
      "prequalify"
    ) : b(
      M,
      ["full", "prequalify", "prescreen"],
      "full"
    );
  }, Q = async (c, g) => {
    (g?.hydrate ?? !0) && await p.hydrateProvider(c), n.switchApplyMode(U(c)), o.switchProvider(c.providerKey), await k();
  }, nt = (c) => dt(c) === "aff_standard", ot = async (c, g) => (await Q(c), g(c)), Re = (c) => {
    if (!c)
      return;
    const g = e.handleReplayDecision;
    if (g && l(c))
      return ot(c, g);
  };
  return $(async () => {
    r.info("Attempting application resume");
    const c = d.value.find(ft);
    if (c)
      return await h(c);
    const g = v.value.find(Ee);
    if (g)
      return await P(g);
    if (R.value.length > 1)
      return await y();
    if (R.value.length === 1)
      return K();
    const N = Re(T());
    if (N)
      return await N;
    r.warn(
      "Un-resumable application data, restarting the application from the top."
    ), await f();
  }), i(() => t.value);
}, Ze = {
  routeParamNames: {
    entityKey: "entityKey",
    token: "token"
  }
}, Tn = (e = Ze) => {
  const t = L();
  return lr(async (r) => {
    await k();
    const n = "/" + vt(r.flowType), o = r.providerKey ? `/providers/${encodeURIComponent(r.providerKey)}` : "", s = r.resume ? "/resume" : "/start", a = `${o}${n}${s}`;
    await t.push(a);
  }, e);
}, lr = (e, t = Ze) => {
  const r = V("use-start-flow.ts"), n = j(), o = C(), s = Fe(), a = yt(), u = Z(
    (h) => s.startFlowWithToken(h)
  ), p = Z(
    (h) => s.startFlowWithEntityKey(h)
  ), l = Z(
    () => s.startFlowWithDefaultEntityKey()
  ), d = Z(
    (h) => s.reevaluateCascade(h)
  ), v = async (h) => {
    r.info("Starting flow with token:", h);
    const P = await u(h);
    return A(P);
  }, w = async (h) => {
    r.info("Starting flow with entity key:", h);
    const P = await p(h);
    return A(P);
  }, R = async () => {
    r.info("Starting flow with default entity key");
    const h = await l();
    return A(h);
  }, E = async () => {
    r.info("Reevaluating Cascade");
    const h = await d({
      launchConfig: {
        prefill: {
          primaryApplicant: {
            address: {
              state: o.application?.primary?.homeAddress?.state,
              zipCode: o.application?.primary?.homeAddress?.zipCode
            }
          }
        }
      }
    });
    return A(h, !0);
  }, A = async (h, P = !1) => {
    await k(), h.flowType === "apply" && !P && a({
      type: "start",
      flow: "application"
    }), await e(h);
  }, T = async () => {
    const h = n.params[t.routeParamNames.token], P = n.params[t.routeParamNames.entityKey], y = !!n.query.reevaluate;
    try {
      h ? await v(h) : P ? await w(P) : y ? await E() : await R();
    } catch (K) {
      throw r.error("Failed to start application", K), K;
    }
  };
  $(() => T());
}, Mn = () => {
  const e = x();
  return i(() => e.testCases);
}, Se = (e) => {
  const t = ve();
  return i(() => F(e) ?? t.group);
};
class cr {
  _fields;
  _parent;
  constructor(t) {
    this._fields = m(/* @__PURE__ */ new Map()), this._parent = t;
  }
  get fields() {
    return [...this._fields.value.values()];
  }
  get count() {
    return this._fields.value.size;
  }
  attach(t) {
    t.id && (this._fields.value.set(t.id, t), this._parent?.attach(t), this.updateRef());
  }
  detach(t) {
    t && (this._fields.value.delete(t), this._parent?.detach(t), this.updateRef());
  }
  isAttached(t) {
    return this._fields.value.has(t);
  }
  updateRef() {
    this._fields.value = new Map(this._fields.value);
  }
}
class Xe {
  wizardById = {};
  layoutById = {};
  sectionById = {};
  constructor(t) {
    t.layouts.forEach((r) => {
      this.layoutById[r.id] = r;
    }), t.sections.forEach((r) => {
      this.sectionById[r.id] = r;
    }), t.wizards.forEach((r) => {
      this.wizardById[r.id] = r;
    });
  }
  findLayoutById(t, r) {
    return this.layoutById[r] ?? null;
  }
  findSectionById(t, r) {
    return this.sectionById[r];
  }
  findWizardById(t, r) {
    return this.wizardById[r];
  }
  static fromConfig(t) {
    return new Xe(t);
  }
}
const le = "default", Ke = "default", pr = "_first", dr = "_last";
class fr {
  id = m("id");
  context;
  fieldController;
  repository;
  stepId;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  overrideSectionProps;
  _stepNumber = i(() => {
    const t = this.stepId.value;
    if (typeof t == "number")
      return t;
    if (t === pr)
      return 1;
    const r = Number(t);
    if (!Et(r))
      return r;
    const n = this.wizard.value?.steps ?? [];
    if (t === dr)
      return n.length || 1;
    const o = n.findIndex(
      (s) => s.id === t
    );
    return o < 1 ? 1 : o + 1;
  });
  wizard = i(() => {
    let t = this.repository.findWizardById(
      this.context.value,
      this.id.value
    );
    return !t && this.id.value !== Ke && (t = this.repository.findWizardById(
      this.context.value,
      Ke
    )), t ? this.materializeWizard(this.context.value, t) : null;
  });
  constructor(t, r) {
    this.context = r.context, this.fieldController = t, this.id = r.id, this.stepId = r.stepId, this.overrideSectionProps = r.sectionProps ?? m({}), this.repository = r.repository;
  }
  get fieldCount() {
    return this.fieldController.count;
  }
  get fields() {
    return this.fieldController.fields;
  }
  get stepNumber() {
    return this._stepNumber.value;
  }
  get previousStepNumber() {
    return this.stepNumber <= 1 ? null : this.wizard.value?.layout?.stepped ? this.stepNumber - 1 : 1;
  }
  get nextStepNumber() {
    const t = this.wizard.value;
    if (!t?.layout?.stepped)
      return null;
    const r = t.steps;
    return this.stepNumber >= r.length ? null : this.stepNumber + 1;
  }
  materializeWizard(t, r) {
    return {
      id: r.id,
      layout: this.materializeLayout(t, r),
      steps: this.steps(t, r).map((n) => this.materializeStep(t, r.id, n))
    };
  }
  materializeStep(t, r, n) {
    return {
      id: n.id,
      sections: n.sections.map((o) => this.materializeSection(t, r, n.id, o))
    };
  }
  materializeSection(t, r, n, o) {
    const s = this.repository.findSectionById(t, o);
    if (!s)
      throw new Error(
        `Section not found: ${o}, step: ${n}, wizard: ${r}`
      );
    return {
      id: s.id,
      component: _e(s.component),
      props: {
        header: s.header,
        ...this.overrideSectionProps.value
      }
    };
  }
  materializeLayout(t, r) {
    const n = r.layout ?? le;
    let o = this.repository.findLayoutById(t, n);
    if (!o && r.layout !== le && (o = this.repository.findLayoutById(t, le)), !o)
      throw new Error(
        `Layout not found: ${n}, wizard: ${r.id}`
      );
    return {
      id: o.id,
      component: _e(o.component),
      stepped: o.stepped,
      props: {}
    };
  }
  steps(t, r) {
    if (t.applyMode === "full")
      return r.full?.steps || [];
    if (t.applyMode === "prescreen")
      return r.prescreen?.steps || [];
    if (t.applyMode === "prequalify")
      return r.prequalify?.steps || [];
    throw new Error(`Unknown apply mode: ${t.applyMode}`);
  }
}
const Dn = {
  phone: "(###) ###-####",
  ssn: "#########",
  ssnHidden: "!*!*!*-!*!*-####"
}, Ce = /* @__PURE__ */ Symbol("fieldController"), vr = () => {
  const e = et(), t = tt(e);
  return ne(Ce, t), t;
}, et = () => B(Ce, null), On = () => B(Ce, tt, !0), tt = (e) => new cr(e), Fn = (e) => {
  const t = et(), r = i(() => ({
    id: e.id
  }));
  return t?.attach(r.value), z(r, (n, o) => {
    o && t?.detach(o.id), n && t?.attach(n);
  }), oe(() => {
    t?.detach(r.value?.id);
  }), r;
}, Ae = /* @__PURE__ */ Symbol(
  "formWizardController"
), $n = (e) => {
  const t = vr(), r = yr(t, e);
  return ne(Ae, r), r;
}, xn = () => B(Ae, null), kn = () => {
  const e = B(Ae);
  if (!e)
    throw new Error("FormWizardController not found");
  return e;
}, yr = (e, t) => new fr(e, t), zn = (e, t, r) => {
  const n = r?.modelKey ?? "modelValue", o = $e(e, n), s = m(o.value);
  return z(o, (a) => {
    a !== s.value && (s.value = a);
  }), z(s, (a) => {
    a !== o.value && t.emit("update:modelValue", a);
  }), r?.init && (s.value = r.init()), {
    originalValue: o,
    internalValue: s
  };
}, Ie = () => {
  const e = ve();
  return i(() => e.theme);
}, Ln = (e) => {
  const t = e?.applyMode ? m(e.applyMode) : he(), r = e?.experience ? m(e.experience) : W(), n = e?.flow ? m(e.flow) : Pe(), o = e?.group ? m(e.group) : Se(), s = e?.provider ? m(e.provider) : _(), a = j(), u = e?.theme ? m(e.theme) : Ie();
  return i(() => ({
    applyMode: t.value,
    experience: r.value,
    flow: n.value,
    group: o.value,
    provider: s.value,
    route: a,
    theme: u.value
  }));
};
function Un(e) {
  const t = Se(), r = i(() => e.group ?? t.value), n = Ie(), o = i(() => e.theme ?? n.value);
  return xe(async () => {
    if (o.value)
      try {
        return (await e.importTheme(o.value)).default;
      } catch {
      }
    if (r.value)
      try {
        return (await e.importGroup(r.value)).default;
      } catch {
        return null;
      }
    return null;
  });
}
function Bn(e, t) {
  const r = Se(), n = i(() => t.group ?? r.value), o = Ie(), s = i(() => t.theme ?? o.value), a = _(), u = i(() => e.value ? ce(e.value) : a.value ? ce(a.value) : null);
  return xe(async () => {
    const p = u.value;
    if (!p)
      return null;
    if (s.value)
      try {
        return (await t.importTheme(s.value, p)).default;
      } catch {
      }
    if (n.value)
      try {
        return (await t.importGroup(n.value, p)).default;
      } catch {
      }
    try {
      return (await t.importProvider(p)).default;
    } catch {
      return null;
    }
  });
}
function Wn() {
  const e = re();
  return i(() => e.location);
}
const Vn = () => {
  const e = se(), t = re();
  return i(
    () => t.supportPhoneNumber ?? e.t("merchant.support_phone_number")
  );
}, Gn = () => {
  const e = re();
  return i(() => e.logoConfig);
}, qn = () => {
  const e = re();
  return i(() => e.splashConfig);
};
function Jn() {
  const e = I();
  return i({
    get() {
      return e.openedPaymentPlan;
    },
    set(t) {
      e.openedPaymentPlan = t;
    }
  });
}
function Hn(e) {
  const t = Ge();
  return i(() => {
    let r = null;
    return typeof e.value == "string" ? r = e.value : typeof e.value == "object" && (r = e.value.expireDateTime), r ? Math.max(
      0,
      mt(
        ht(/* @__PURE__ */ new Date()),
        r,
        mr(t.value)
      )
    ) : null;
  });
}
function mr(e) {
  return e === "proceed_standard";
}
const hr = (e) => {
  const t = ye();
  return i(() => t.isCallActive(e));
};
function jn() {
  return hr("getPaymentPlans");
}
const gr = (e) => {
  const t = I(), r = _(), n = i(() => F(e ?? void 0) ?? r.value);
  return i(() => n.value ? t.findPaymentPlans(n.value) : {
    paymentPlans: []
  });
}, Yn = () => {
  const e = gt(), t = gr(), r = m(), n = async () => {
    const s = r.value;
    if (!s)
      throw new Error("Plan has not been selected");
    const a = t.value.paymentPlans.find(
      (u) => u.providerPlanCode === s
    );
    if (!a)
      throw Error(
        s + " is not a valid plan for the current provider"
      );
    await e.selectPaymentPlan(a);
  }, o = i(() => t.value.paymentPlans);
  return { model: r, items: o, commit: n };
}, Qn = () => {
  const e = C();
  return i({
    get: () => e.selectedPlan,
    set: (t) => e.selectedPlan = t
  });
}, rt = (e) => {
  const t = m(), r = Rt(async (n) => {
    let o = !1;
    n(() => {
      o = !0;
    });
    const s = await e();
    o || (t.value = s);
  });
  return oe(() => {
    r();
  }), i(() => t.value);
}, wr = (e, t) => {
  const r = rt(e);
  return i(() => r.value ?? t);
}, Zn = (e) => {
  const t = _(), r = i(() => ee(e) || t.value), n = me(), o = m(!0), s = m(!1);
  return [rt(async () => {
    if (!r.value)
      throw new Error("No provider value for useMerchantDisclaimerResponse");
    try {
      o.value = !0;
      const u = await n.getMerchantDisclaimerResponse(
        r.value
      );
      return u === void 0 && (s.value = !0), (u?.minPurchaseAmountCents === void 0 || u?.minInterestRate === void 0 || u?.maxPurchaseAmountCents === void 0) && (s.value = !0), u;
    } finally {
      o.value = !1;
    }
  }), o, s];
}, Xn = (e) => {
  const t = m(!1), r = m(!1), n = V("WellsFargoSDK"), o = Ft(), s = me(), a = te(), u = Wt(), p = m(), l = wt(), d = Kt(), v = Y(), w = i(() => l.value?.applicantType == O.JOINT ? v?.value?.joint : v?.value?.primary), R = async (P) => new Promise((y) => {
    if (window.WF_SDK_BOOTSTRAP != null) {
      y();
      return;
    }
    const K = document.createElement("script");
    K.src = P, K.onload = () => {
      y();
    }, document.head.appendChild(K);
  }), E = async (P, y) => {
    r.value = !0, p.value?.hide();
    try {
      const K = await s.postSdkResults(o.value, {
        status: P,
        applicationId: y?.application_id,
        approvalAmount: y?.credit_line,
        accountNumber: y?.credit_card_number,
        firstName: y?.first_name,
        lastName: y?.last_name,
        errorCode: y?.error_code,
        errorMessage: y?.error_message
      }), D = await a.addExternalResponse({
        ...K,
        applyMode: "full"
      });
      return await k(), d.emit("decision", D), D;
    } finally {
      r.value = !1;
    }
  };
  $(async () => {
    const P = v.value;
    if (!P)
      throw new Error("Invalid application state");
    const y = await s.launchSdkApply(o.value, {
      application: P
    });
    if (!y.sdkUrl)
      throw new Error("Unable to load Wells Fargo SDK - No SDK URL received");
    if (!y.merchantNumber)
      throw new Error(
        "Unable to load Wells Fargo SDK - No Merchant Number received"
      );
    if (!y.sdkEnvironment)
      throw new Error(
        "Unable to load Wells Fargo SDK - No SDK Environment received"
      );
    await R(y.sdkUrl);
    let D = {
      silentInit: !0,
      secureConfigurationUrl: `${s.config.baseUrl || ""}/api/v1/providers/${encodeURIComponent(
        o.value
      )}/sdk/token`,
      partnerHeaders: [
        {
          name: At,
          value: u.value
        }
      ],
      targetDivId: e.targetElementId,
      scrollingContainerId: e.scrollingContainerId,
      merchantNumber: y.merchantNumber,
      brandIdentifier: y.sdkBrandId || "lean",
      loggingEnabled: !0,
      consoleLoggingEnabled: !0,
      environment: y.sdkEnvironment,
      application_id: l.value?.applicationId,
      prefill: {
        first_name: w.value?.firstName,
        last_name: w.value?.lastName,
        email: w.value?.email,
        address_line_1: w.value?.homeAddress?.line1,
        city: w.value?.homeAddress?.city,
        state_code: w.value?.homeAddress?.state,
        postal_code: w.value?.homeAddress?.zipCode,
        mobile_phone: w.value?.mobilePhone,
        home_phone: w.value?.homePhone,
        work_phone: w.value?.workPhone,
        purchase_price: v?.value?.purchaseAmountCents ? (v.value.purchaseAmountCents / 100).toString() : void 0
      },
      callbacks: {
        general: {
          start: (f) => {
            n.info(`general.start: ${JSON.stringify(f)}`);
          },
          ready: (f) => {
            n.info(`general.ready: ${JSON.stringify(f)}`), t.value = !0, d.emit("ready");
          },
          exit: (f) => {
            n.info(`general.exit: ${JSON.stringify(f)}`);
          },
          log: (f) => {
            n.info(`general.log: ${JSON.stringify(f)}`);
          },
          error: async (f) => {
            const b = f;
            if (b.errorDescription) {
              const U = b.errorDescription.indexOf("arg");
              U > -1 && (b.errorDescription = b.errorDescription.slice(
                0,
                U
              ));
            }
            n.error(`general.error: ${JSON.stringify(b)}`), await E(S.ERROR, b);
          },
          secure_configuration_error: (f) => {
            n.error(
              `general.secure_configuration_error: ${JSON.stringify(f)}`
            );
          }
        },
        application: {
          start: (f) => {
            n.info(`application.start: ${JSON.stringify(f)}`);
          },
          start_over: (f) => {
            n.info(`application.start_over: ${JSON.stringify(f)}`);
          },
          terms_and_conditions: (f) => {
            n.info(
              `application.terms_and_conditions: ${JSON.stringify(f)}`
            ), A();
          },
          approved: async (f) => {
            n.info(`application.approved: ${JSON.stringify(f)}`), A(), await E(S.APPROVED, f);
          },
          denied: async (f) => {
            n.info(`application.denied: ${JSON.stringify(f)}`), A(), await E(S.DECLINED, f);
          },
          pending: async (f) => {
            n.info(`application.pending: ${JSON.stringify(f)}`), A(), await E(S.PENDING, f);
          },
          error: async (f) => {
            const b = f;
            if (b.errorDescription) {
              const U = b.errorDescription.indexOf("arg");
              U > -1 && (b.errorDescription = b.errorDescription.slice(
                0,
                U
              ));
            }
            n.error(`application.error: ${JSON.stringify(b)}`), A(), await E(S.ERROR, b);
          },
          recoverable_error: (f) => {
            n.error(
              `application.recoverable_error: ${JSON.stringify(f)}`
            );
          },
          approved_displayed: (f) => {
            n.info(
              `application.approved_displayed: ${JSON.stringify(f)}`
            );
          },
          completed: (f) => {
            n.info(`application.completed: ${JSON.stringify(f)}`);
          }
        }
      }
    };
    y.sdkVersion === "V3_0" ? D = {
      ...D,
      gatewayEntityId: y.gatewayEntityId,
      additionalAncestors: y.sdkAdditionalAncestors
    } : D = {
      ...D,
      sdkVersion: "2.1.latest"
    }, p.value = WF_SDK_BOOTSTRAP.initialize(D);
  });
  const A = () => {
    window.scrollTo(0, 0);
  };
  return {
    apply: () => {
      p.value && p.value.display("application");
    },
    busy: r,
    on: (P, y) => {
      d.on(P, y);
    },
    ready: t
  };
}, Pr = (e, t, r) => {
  if (typeof t == "number")
    return e.go(t), Promise.resolve();
  if (t === "back")
    return e.go(-1), Promise.resolve();
  if (t === "forward")
    return e.forward(), Promise.resolve();
  let n;
  return typeof t == "string" ? n = {
    path: t,
    ...r
  } : r ? n = { ...t, ...r } : n = t, n.replace ? e.replace(n) : e.push(n);
}, eo = () => {
  const e = Pt();
  return i(() => {
    const t = window.history;
    if (!t)
      return !1;
    if (!t.state)
      return !0;
    if (!t.state.back)
      return !1;
    const r = t.state.position;
    if (r == null)
      return !0;
    const n = e.backPosition;
    return n == null ? !0 : r > n;
  });
}, to = () => {
  const e = L();
  return (t, r) => Pr(e, t, r);
}, ro = () => L(), no = (e, t) => {
  const r = Le(), n = _();
  return wr(async () => {
    const o = t ?? n.value;
    if (!o)
      return [];
    try {
      const { disclosures: s } = await r.getDisclosures(
        o,
        e
      );
      return s;
    } catch (s) {
      return console.error(
        `Error Retrieving Disclosures for provider [${o}]` + (e ? ` and type [${e}]` : "") + ":",
        s
      ), [];
    }
  }, []);
}, oo = (e, t, r) => {
  const n = $e(e, t);
  return i(() => n.value || r.value);
}, so = () => {
  const e = Ue(), t = tr(), r = Pe(), n = V("useSendVerificationCode");
  return async (o, s) => {
    try {
      const a = await e.sendVerificationCode(
        o,
        s
      );
      return r.value === "apply" && (o.email && t("primary.email", o.email), o.mobilePhone && t("primary.mobilePhone", o.mobilePhone)), a;
    } catch (a) {
      return n.error(
        `Error sending verification code for provider ${s}: `,
        a
      ), {
        status: "error"
      };
    }
  };
}, io = () => {
  const e = Ue(), t = V("useVerifyVerificationCode");
  return async (r, n) => {
    try {
      return await e.verifyVerificationCode(
        r,
        n
      );
    } catch (o) {
      return t.error(
        `Error verifying verification code for provider ${n}: `,
        o
      ), {
        status: It.ERROR
      };
    }
  };
};
export {
  Nr as ApplicationField,
  cr as FieldController,
  fr as FormWizardController,
  Xe as FormWizardRepository,
  Dn as MaskHelpers,
  rt as asyncComputed,
  wr as asyncComputedWithDefault,
  en as buildApplyResponseRouteLocation,
  Xr as buildApplyStageRoutePath,
  Je as buildProviderRouteLocation,
  qe as buildProviderRoutePath,
  je as getApplyModeFromOperation,
  jt as getApplyStageFromOperation,
  vr as hostFieldController,
  $n as hostFormWizard,
  tn as isAmbiguousResponseCode,
  Pr as navigate,
  Yt as navigateByApplyResponse,
  qt as navigateByApplyStage,
  we as navigateByProvider,
  zr as overrideCurrentProvider,
  wn as providePageTitle,
  Ft as requireCurrentProvider,
  kr as requireCurrentProviderConfig,
  oo as toRefWithDefault,
  lo as useAcceptOffer,
  Or as useAccountService,
  En as useApiError,
  Tr as useApplicantIncome,
  Mr as useApplicantName,
  Y as useApplication,
  co as useApplicationService,
  Ot as useApplicationValue,
  he as useApplyMode,
  ze as useApplyResponses,
  ke as useApplyStage,
  $r as useApplyTermsContent,
  Dr as useApprovedResponses,
  Sn as useAsync,
  or as useAsyncOperation,
  Pn as useAutoDetectPageTitle,
  mn as useBankName,
  hn as useBankNameAbbreviation,
  eo as useCanGoBack,
  Be as useCascadeProviders,
  xr as useCompleteApplication,
  gn as useComponentRef,
  _ as useCurrentProvider,
  Ve as useCurrentProviderConfig,
  Ge as useCurrentProviderKey,
  xt as useCurrentlySubmittableProviderConfigs,
  Lr as useCurrentlySubmittableProviderModules,
  lr as useCustomStartFlow,
  Ur as useDefineProviderRoute,
  no as useDisclosures,
  An as useElement,
  sr as useEnvironmentName,
  Kn as useExitFlow,
  W as useExperienceType,
  Fn as useField,
  On as useFieldController,
  po as useFlowService,
  Jr as useFlowSessionId,
  Pe as useFlowType,
  kn as useFormWizardController,
  In as useGlobalEventListener,
  Fr as useGoogleTagManager,
  Se as useGroupId,
  Br as useHasMultipleProviders,
  Rn as useInterval,
  Wr as useIsAtHome,
  Cn as useIsContentDownloadSupported,
  Vr as useIsInStore,
  Yr as useIsInitialApplicationForm,
  bn as useIsNonProd,
  ir as useIsProd,
  Gr as useIsSessionActive,
  Qr as useJointEnabled,
  Zr as useJointSelectionEnabled,
  Ln as useLocalizationContext,
  Un as useLocalizedImporter,
  Bn as useLocalizedProviderImporter,
  fo as useLogger,
  ro as useLogicalRouter,
  Zn as useMerchantDisclaimerResponse,
  vo as useMerchantLegalName,
  Wn as useMerchantLocation,
  Gn as useMerchantLogo,
  yo as useMerchantName,
  qn as useMerchantSplash,
  Vn as useMerchantSupportPhoneNumber,
  zn as useModel,
  rn as useNavigateByApplyResponse,
  Jt as useNavigateByApplyStage,
  Hr as useNavigateByProvider,
  to as useNavigation,
  Co as useOmniApplyApiClient,
  Jn as useOpenedPaymentPlan,
  et as useOptionalFieldController,
  xn as useOptionalFormWizardController,
  nn as useOriginalApplication,
  on as usePatchApplication,
  mo as usePaymentPlanService,
  gr as usePaymentPlans,
  Hn as usePlanExpirationDays,
  jn as usePlansLoading,
  Qt as usePrequalifyResponses,
  ln as usePreviousManuallySubmittedProviderResponse,
  un as usePreviousManuallySubmittedProviderResponses,
  Gt as usePrimaryProvider,
  an as usePrimaryProviderApplyMode,
  $t as useProviderConfig,
  sn as useProviderDownPaymentAmount,
  Vt as useProviderModule,
  cn as useRefreshPendingStipulation,
  Nn as useResumeApplyFlow,
  Yn as useSelectablePaymentPlans,
  Qn as useSelectedPlan,
  so as useSendVerificationCode,
  pn as useSessionStipulations,
  qr as useSessionTimeout,
  nr as useSetPageTitle,
  yn as useShowEmploymentInfo,
  dn as useShowMultiLenderReviewCheckbox,
  Tn as useStartFlow,
  ho as useStipulationService,
  go as useSubmitApplication,
  jr as useSwitchableProvider,
  Le as useTermsService,
  wo as useTestCaseService,
  Mn as useTestCases,
  Ie as useThemeId,
  tr as useUpdateApplicationValue,
  vn as useUpdateApplicationValues,
  _n as useUserFriendlyError,
  fn as useValidateBankCard,
  Po as useValidationService,
  Ue as useVerificationService,
  io as useVerifyVerificationCode,
  Wt as useWebSessionId,
  Xn as useWellsFargoSdk
};
//# sourceMappingURL=index.es.js.map
